<template>
  <v-system-bar absolute app window color="#004056" class="d-flex" style="height: 55px">
    <div class="d-flex flex-column align-start justify-center">
      <div class="white--text" style="font-size: 16px;">
        {{ name }}
      </div>
      
      <div class="white--text" style="font-size: 12px;">
        {{ account_name }}
      </div>
    </div>

    <div class="ml-auto pt-1">
      <img src="@/assets/referra-store-pros-every-project-316x104.png" height="35px" />
    </div>
  </v-system-bar>
</template>

<script>

export default {
  name: 'AppHeader',

  props: ['name', 'account_name'],
}

</script>